import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle, withState } from "recompose";
import { withRouter } from "react-router-dom";
import {find, forEach, map} from "lodash";
import classNames from "classnames";

import { Button, Card } from "react-md";

import TableUsers from "../../components/organization/TableUsers";
// import TablePackages from "../../components/packages/Table_forUserOrganization";
import TablePackages from "../../components/packages/Table";

import {DebugElement} from "../../Atollon/debug";

import {
    getOrganization,
    getPackages,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser,
    getOrganizationTemplates,
    getOrganizationUsers,
    getOrganizationUserDetail
} from "../../actions/resourceActions";
import {
    setActiveHost,
    setActiveServer,
    setActiveOrganization
} from "../../actions/activeActions";
import { setDialog } from "../../actions/dialogActions";
import {array_utilities} from "../../Atollon/utilities/array_utilities";


/**
 *
 * @param match
 * @param location
 * @param history
 * @param host
 * @param server
 * @param packages
 * @param setActiveHost
 * @param setActiveServer
 * @param setActiveOrganization
 * @param setDialog
 * @param getOrganizationTemplates
 * @param state
 * @param setState
 * @param tabsState
 * @param setTabsState
 * @param getOrganizationUsersAdmin
 * @param getOrganizationUsersOwner
 * @param getOrganizationUsersUser
 * @param organizationUsersAdmin
 * @param organizationUsersOwner
 * @param organizationUsersUser
 * @returns {*}
 * @constructor
 *
 */

const TAB_PACKAGES = 0;
const TAB_USERS = 1;

const UsersAndPackages_forUserOrganization = ({
                              match,
                              location,
                              history,
                              //host,
                              //server,
                              organization,
                              packages,
                              setActiveHost,
                              setActiveServer,
                              setActiveOrganization,
                              setDialog,
                              getOrganizationTemplates,
                              state,
                              setState,
                              tabsState,
                              setTabsState,
                              getOrganizationUsersAdmin,
                              getOrganizationUsersOwner,
                              getOrganizationUsersUser,
                              organizationUsersAdmin,
                              organizationUsersOwner,
                              organizationUsersUser,
                              organizationUsers,
                              organizationUserDetails
                          }) => {

    const allUsers = [];

    forEach(organizationUsersAdmin, u => {
        allUsers.push({ ...u, role: "admin" });
    });
    forEach(organizationUsersOwner, u => {
        allUsers.push({ ...u, role: "owner" });
    });
    forEach(organizationUsersUser, u => {
        allUsers.push({ ...u, role: "user" });
    });

    if (organization) {
        return (
            <Card className="padding-bottom">
                <DebugElement text="components/organization/UsersAndPackage.js BEGIN"/>
                <div className="flex-row flex-centered">
                    <Button
                        flat
                        {...{
                            className: classNames("btn half-width margin-none padding", {
                                "btn-primary": tabsState === TAB_USERS
                            }),
                            onClick: () => setTabsState(TAB_USERS)
                        }}
                    >
                        Uživatelé
                    </Button>
                    <Button
                        flat
                        {...{
                            className: classNames("btn half-width margin-none padding", {
                                "btn-primary": tabsState === TAB_PACKAGES
                            }),
                            onClick: () => setTabsState(TAB_PACKAGES)
                        }}
                    >
                        Balíčky
                    </Button>
                </div>
                {tabsState === TAB_PACKAGES ? (
                    <div className="flex-col">
                        <div className="flex-row padding">
                            <h2>Balíčky</h2>
                        </div>
                        {/*

                            TODO: this

                            host={host}
                            server={server}
                        */
                        <TablePackages
                            packages={packages}
                            admin
                            history={history}
                            organization={organization}
                        />}
                    </div>
                ) : (
                    <div className="flex-col">
                        <div className="flex-row flex-space-between padding">
                            <h2>Uživatelé s SSO</h2>
                            <Button
                                raised
                                className="btn btn-primary"
                                onClick={() => {
                                    getOrganizationTemplates(organization.id);
                                    setDialog("OrganizationUserAdministration_Dialog", {
                                        organizationId: organization.id,
                                        onClose: () => setState(!state)
                                    });
                                }}
                            >
                                Přidat uživatele
                            </Button>
                        </div>

                        <TableUsers {...{users: allUsers, organization}} organizationUserDetails={organizationUserDetails} history={history} />

                        <div style={{height:'31px'}}></div>
                        <div className="flex-row flex-space-between padding">
                            <h2>Všichni uživatelé</h2>
                        </div>
                        <TableUsers {...{users: organizationUsers, organization}} history={history} organizationUserDetails={organizationUserDetails} listUsersWithoutSSO={true} />
                    </div>
                )}
                <DebugElement text="components/organization/UsersAndPackage.js END"/>
            </Card>
        );
    }

    return <div />;
};

export default compose(
    withRouter,
    connect(
        (wholeState) => {
            let {
                resource: {
                    packages,
                    organizationUsersAdmin,
                    organizationUsersOwner,
                    organizationUsersUser,
                    organizationUsers,
                    organizationUserDetails
                }
            } = wholeState;
         return {
             wholeState,
             packages,
             organizationUsersAdmin,
             organizationUsersOwner,
             organizationUsersUser,
             organizationUsers,
             organizationUserDetails
         };
        },
        {
            //getOrganization,
            getPackages,
            setActiveHost,
            setActiveServer,
            setActiveOrganization,
            getOrganizationUsersAdmin,
            getOrganizationUsersOwner,
            getOrganizationUsersUser,
            setDialog,
            getOrganizationTemplates,
            getOrganizationUsers,
            getOrganizationUserDetail
        }
    ),
    withState("state", "setState", true),
    withState("tabsState", "setTabsState", TAB_USERS),
    lifecycle({
        async componentWillMount() {
            const {
                match,
                host,
                server,
                //getOrganization,
                getPackages,
                getOrganizationUsersAdmin,
                getOrganizationUsersOwner,
                getOrganizationUsersUser,
                getOrganizationUsers,
                getOrganizationUserDetail
            } = this.props;

            var organizationUuid = match.params.id;
            //await getOrganization(host.id, server.id, match.params.id);
            await getPackages(organizationUuid);
            await getOrganizationUsersAdmin(organizationUuid);
            await getOrganizationUsersOwner(organizationUuid);
            await getOrganizationUsersUser(organizationUuid);
            await getOrganizationUsers(organizationUuid);

            //
            // get all users which are available
            //
            // TODO: cleanup? Pasted from organization/TableUsers.js
            {
                const usersBoundToInstance = [];

                forEach(this.props.wholeState.resource.organizationUsersAdmin, u => {
                    usersBoundToInstance.push({ ...u, role: "admin" });
                });
                forEach(this.props.wholeState.resource.organizationUsersOwner, u => {
                    usersBoundToInstance.push({ ...u, role: "owner" });
                });
                forEach(this.props.wholeState.resource.organizationUsersUser, u => {
                    usersBoundToInstance.push({ ...u, role: "user" });
                });
                map( usersBoundToInstance, (item) => {

                    let organizationId = organizationUuid;
                    let userId = item.name; // FIXME:
                    getOrganizationUserDetail(organizationId, userId);
                });
            }
        }
    })
)(UsersAndPackages_forUserOrganization);



// WEBPACK FOOTER //
// ./src/components/organization/UsersAndPackages_forUserOrganization.js